<template>
  <div>
    <div class="filter-label-text pb-2">Commercial invoice
      <v-tooltip top dark max-width="350px">
        <template slot="activator">
          <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
        </template>
        <span>Upload purchase documents</span>
      </v-tooltip>
    </div>
    <v-btn
      :loading="loading"
      @click="$refs.inputUpload.click()"
      class="upload-file mb-4 text-xs-center text-lg-center text-sm-center text-md-center mx-0"
      flat
      color="white"
      v-model="invoice"
    >
      <v-layout align-center row justify-center fill-height>
        <img :src="require('@/assets/baseline-attach_file-24px.svg')"/>
        <span class="upload-file-text">Attach invoice</span>
      </v-layout>
    </v-btn>
    <input v-show="false" ref="inputUpload" type="file" @change="uploadFiles" accept="application/pdf">
  </div>
</template>

<script>
  import OrderService from '@/services/Orders'

  export default {
    name: "AddOrderCommercialInvoice",
    data() {
      return {
        filesPdf: null,
        invoice: null,
      }
    },
    created() {
      /**
       * Watch to event for remove and close pdf file
       */
      this.$store.watch(
        (state) => {
          if (state.orders.eventForAddOrder === 'close') {
            this.closePdf()
            this.$store.dispatch('setEventForAddOrder', null)
          }
        },
      );
    },
    computed: {
      /**
       * Get value if loading some this time
       * @returns {*}
       */
      loading() {
        return this.$store.getters.loading
      }
    },
    methods: {
      /**
       * Remove and close pdf file
       */
      closePdf() {
        this.filesPdf = null
        if (this.$refs.inputUpload && this.$refs.inputUpload.value)
          this.$refs.inputUpload.value = ''
        if (this.$store.getters.getPdf && this.$store.getters.getPdf.id)
          this.removePdf(this.$store.getters.getPdf.id)
      },
      /**
       * Remove pdf file by id
       */
      removePdf(id) {
        this.$store.commit('setLoading', true)
        OrderService.removePdf(id)
          .then(() => {
          })
          .catch(error => {
            this.$store.commit('setError', error.response.message)
          })
          .finally(() => {
            this.$store.commit('setLoading', false)
          })
        // if (this.$store.getters.getPdf && this.$store.getters.getPdf.id && this.$store.getters.getPdf.id === id)
        this.$store.commit('setPdf', null)
      },
      /**
       * Uploading and view pdf file
       */
      uploadFiles() {
        if (this.$refs.inputUpload.files[0].type === this.$typeFiles.pdf) {
          this.$store.commit('setLoading', true)
          this.filesPdf = this.$refs.inputUpload.files[0]
          if ((this.filesPdf.size / 1000) <= this.$validateFiles.maxPdfSize) {
            let formData = new FormData()
            formData.append('invoice', this.filesPdf)
            OrderService.loadingPdf(formData)
              .then(response => {
                if (response.status === this.$response.Ok) {
                  if (this.$store.getters.getPdf && this.$store.getters.getPdf.id)
                    this.removePdf(this.$store.getters.getPdf.id)
                  this.$store.dispatch('setPdf', response.data.data)
                  this.$store.dispatch('setPdfFile', this.filesPdf)
                }
              })
              .catch(error => {
                this.$store.commit('setError', error.response.message)
              })
              .finally(() => {
                this.$store.commit('setLoading', false)
              })
          } else {
            this.$store.commit('setLoading', false)
            this.$store.commit('setError', this.filesPdf.name + ' - maximum size limit is exceeded')
          }

        }
      },
    }
  }
</script>

<style scoped lang="stylus">
  .upload-file
    background-color #008EFF
    width 100%
    border-radius 6px
    height 52px !important
    margin-top 0 !important

  .upload-file-text
    text-transform none
    color #fff
    font-size 16px
    font-weight 600
</style>
